/**
 * @description 告警统计 countAlarm
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const countAlarmBiz = new Logic()

countAlarmBiz.getAlarmCount = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.countAlarm.getAlarmCount,
    data: data
  })
}

export default countAlarmBiz
